import { Injectable } from '@angular/core';
import { isNullish } from '@commonHelpers/math-utils';
import { RequestService } from '@commonServices/request.service';
import { Client as CatalogPublicAPI, CatalogViewNewsListDto, InhouseNewsDto } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { firstValueFrom, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class InfocenterService {

	private static newsCatalogKey;
	private static catalogNewsCache;
	private static inhouseNewsCache;

	constructor(
		private catalogPublicAPI: CatalogPublicAPI,
		private requestService: RequestService,
	) { }

	async getCatalogNewsForDialog(catalogKey: string): Promise<CatalogViewNewsListDto> {
		try {
			if (catalogKey === InfocenterService.newsCatalogKey) {
				return firstValueFrom(of(InfocenterService.catalogNewsCache))
			}
			const result = await firstValueFrom(this.catalogPublicAPI
				.catalogView_GetNewsForDialog(catalogKey));
			InfocenterService.newsCatalogKey = catalogKey;
			InfocenterService.catalogNewsCache = result;
			return result;
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getInhouseNewsForDialog(): Promise<InhouseNewsDto[]> {
		try {
			if (isNullish(InfocenterService.inhouseNewsCache)) {
				const result = await firstValueFrom(this.catalogPublicAPI
					.infocenter_GetNewsForDialog());
				InfocenterService.inhouseNewsCache = result;
				return result;
			} else {
				return InfocenterService.inhouseNewsCache;
			}

		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}

	async getInhouseAdminNewsForDialog(): Promise<InhouseNewsDto[]> {
		try {
			if (isNullish(InfocenterService.inhouseNewsCache)) {
				const result = await firstValueFrom(this.catalogPublicAPI
					.infocenter_GetAdminNewsForDialog());
				InfocenterService.inhouseNewsCache = result;
				return result;
			} else {
				return InfocenterService.inhouseNewsCache;
			}

		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: 204, return: undefined }
			]);
		}
	}


}
